import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../context/I18nContext";
import "./Footer.css";

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div className="footer-col">
          <h4>{t("footer.title")}</h4>
          <p>{t("footer.description")}</p>
        </div>
        <div className="footer-col">
          <h5>{t("footer.quickLinks")}</h5>
          <Link to="/">{t("footer.home")}</Link>
          <Link to="/courses">{t("footer.courses")}</Link>
          <Link to="/about">{t("footer.about")}</Link>
        </div>
        <div className="footer-col">
          <h5>{t("footer.contact")}</h5>
          <a href="mailto:contact@casaclassroom.com">{t("footer.email")}</a>
          <a href="tel:+21655544475" className="footer-phone">
            {t("footer.phone")}
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        © {currentYear} {t("footer.title")} {t("footer.copyright")}
      </div>
    </footer>
  );
}

export default Footer;
